import React, { ReactNode } from "react";

import { isBlank } from "../previewFund";
import styles from "../previewFund.module.scss";

export type TDetail = {
  label: string;
  value?: ReactNode;
  /** Takes the whole row, under a rule — for prose like a description. */
  wide?: boolean;
};

/**
 * Labels over values, in as many columns as fit.
 *
 * A missing value reads "Not set", muted, rather than "N/A" in the same
 * weight as real data — the old screen made an empty fund look full.
 */
export default function DetailList({ items }: { items: TDetail[] }) {
  return (
    <dl className={styles.details}>
      {items.map(({ label, value, wide }) => (
        <div key={label} className={wide ? styles.detailWide : undefined}>
          <dt className={styles.detailLabel}>{label}</dt>
          <dd
            className={`${styles.detailValue} ${
              isBlank(value) ? styles.notSet : ""
            }`}
          >
            {isBlank(value) ? "Not set" : value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
